import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { SafeHtml } from '@angular/platform-browser';

export interface ProgressBarModel {
  title?: string | SafeHtml;
  subtitle?: string | SafeHtml;
  level: number;
  theme?: 'green' | 'white';
}
@Component({
  selector: 'sb-progress-bar',
  templateUrl: './progress-bar.component.html',
  styleUrl: './progress-bar.component.scss',
  standalone: true,
  imports: [CommonModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ProgressBarComponent {
  @Input()
  public title?: string | SafeHtml;
  @Input()
  public subtitle?: string | SafeHtml;
  @Input()
  public level!: number;
  @Input()
  public theme = 'green';
}
